import "./RemoveResourceConfirmationModal.styles.scss";
import React, { useEffect } from "react";
import { Icon, Button } from "components";
import WarningIcon from "assets/icons/exclamation-triangle.svg";
import { useUnassignLibraryResource, useUnassignCollection } from "utils/hooks";

const RemoveResourceConfirmationModal = ({
  resource,
  collection,
  onCancel,
  group,
}) => {
  const { unassignLibraryResource, success } = useUnassignLibraryResource({
    resourceId: resource?.uuid,
    groupId: group?.uuid,
  });
  const { unassignCollection, success: unassCollSuccess } =
    useUnassignCollection({
      collectionId: collection?.uuid,
      groupId: group.uuid,
    });

  useEffect(() => {
    if (success) onCancel();
  }, [success, onCancel]);

  useEffect(() => {
    if (unassCollSuccess) onCancel();
  }, [unassCollSuccess, onCancel]);

  return (
    <div className="resource-removal-confirmation">
      <div className="resource-removal-confirmation__icon">
        <Icon src={WarningIcon} alt="Warning Icon" />
      </div>
      <div className="resource-removal-confirmation__title">
        Are you sure you want to remove this resource?
      </div>
      <div className="resource-removal-confirmation__body">
        {group.name} will no longer have access.
      </div>
      <div className="resource-removal-confirmation__buttons">
        <Button
          onClick={onCancel}
          name={`cancel_remove_resource_button`}
          value="Never mind"
          extraClass="secondary-bland"
          size="small"
        />
        <Button
          onClick={() => {
            collection ? unassignCollection() : unassignLibraryResource();
          }}
          name={`confirm_remove_resource_button`}
          value="Yes, remove it"
          extraClass="danger"
          size="small"
        />
      </div>
    </div>
  );
};

export default RemoveResourceConfirmationModal;
